const isDocplePlusSubdomain = () => {
  return window.location.hostname.endsWith('.docple-plus.com');
};

export const getApiConfig = () => {
  return {
    baseURL: isDocplePlusSubdomain() ? 'https://docple.docple-plus.com' : '',
    timeout: 10000,
  };
};
